import type {MaterialList} from "../../../types/materials.types";

import {deleteMaterial} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../material-keys";

export function deleteMaterialMutationOptions() {
  const listFilter = {queryKey: materialKeys.lists()};

  return mutationOptions({
    mutationKey: materialMutationKeys.deleteMaterial,
    mutationFn: (id: string) => deleteMaterial(id),
    onMutate: async (id, {client}) => {
      await client.cancelQueries(listFilter);
      const previousLists = client.getQueriesData<MaterialList>(listFilter);

      for (const [key, list] of previousLists) {
        const params = key[2];
        if (
          !list ||
          typeof params !== "object" ||
          params === null ||
          !("state" in params) ||
          params.state !== "ACTIVE" ||
          !list.items.some((item) => item.materialId === id)
        ) {
          continue;
        }
        client.setQueryData<MaterialList>(key, {
          ...list,
          items: list.items.filter((item) => item.materialId !== id),
          meta: {...list.meta, total: Math.max(0, list.meta.total - 1)},
        });
      }
      return {previousLists};
    },
    onError: (_error, _id, context, {client}) => {
      for (const [key, snapshot] of context?.previousLists ?? []) {
        client.setQueryData(key, snapshot);
      }
    },
    onSuccess: async (_result, id, _context, {client}) => {
      client.removeQueries({queryKey: materialKeys.detail(id)});
      await client.invalidateQueries(listFilter);
    },
  });
}
